import Mutations from '../../odata/mutations';

export default { ...new Mutations('xeroChartOfAccounts'), ...new Mutations('xeroChartOfAccount') };
